<template src="./template.html"></template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import weighStationsApi from '@/api/weighStations.js'
import zonesApi from '@/api/zones'

export default {
  name: 'weighStationShow',
  inject: ['companyUser', 'showPopup'],
  data() {
    return {
      weighStation: {},
      loading: true,
      zones: [],
      templateMode: 'edit',
    }
  },
  components: { BreadCrumbs, CompanyNav, LoadingSpinner, SectionHeader },
  methods: {
    async deleteWeighStation() {
      const popupResult = await this.showPopup({
        type: 'confirm',
        content: this.$t('weighStations.deleteConfirmation'),
      })
      if (!popupResult) return null

      const result = await weighStationsApi.delete(this.weighStation.uuid)

      if (result.success) this.$router.push({ name: 'weigh_stations' })
    },
    async submitWeighStation() {
      const updatedStation = await weighStationsApi.update(this.weighStation.uuid, this.weighStation)

      if (updatedStation) this.$router.push({ name: 'weigh_stations' })
    },
  },
  async mounted() {
    this.zones = await zonesApi.getAllForCompany(this.companyUser.company_uuid)

    this.weighStation = await weighStationsApi.get(this.$route.params.weigh_station_uuid)

    if (this.zones.length) this.weighStation.zone = this.zones[0].uuid

    this.loading = false
  },
}
</script>

<style lang="scss" scoped></style>
